import { render, staticRenderFns } from "./setLabelType.vue?vue&type=template&id=63b336d2&scoped=true&"
import script from "./setLabelType.vue?vue&type=script&lang=js&"
export * from "./setLabelType.vue?vue&type=script&lang=js&"
import style0 from "./setLabelType.vue?vue&type=style&index=0&id=63b336d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b336d2",
  null
  
)

export default component.exports